$(document).on('click', '.img-group__media[data-open="mdl-full-size-slider"]', function(){
    $('.img-group.active').wrapAll('<div class="group-wrap"></div>');
    $('.group-wrap').find('.img-group__media').each(function(i){
        $(this).attr('data-index', i);
    });
    var index = $(this).attr('data-index');
    $('.mdl-slider').slick('slickGoTo', index);
    setTimeout((() => {
        $('.img-group.active').unwrap();
    }).bind(this), 100);
});